import { Routes } from '@angular/router';

import { TrackingOtpComponent } from './lead-tracking/tracking-otp';
import { LandingPage } from './landing-page/landing-page';
import { MyRequestsComponent } from './my-requests/my-requests';
import { RequestDetailsComponent } from './request-details/request-details';

export const routes: Routes = [
  {
    path: '',
    data: { seoKey: 'landing' },
    component: LandingPage,
  },
  {
    path: 'personal-fund-request',
    loadChildren: () =>
      import('./personal-fund-request/personal-fund-request.module').then(
        (module) => module.PersonalFundRequestModule,
      ),
  },
  {
    path: 'my-requests',
    data: { seoKey: 'myRequests', robots: 'noindex, follow' },
    component: MyRequestsComponent,
  },
  {
    path: 'request-details',
    data: { seoKey: 'requestDetails', robots: 'noindex, follow' },
    component: RequestDetailsComponent,
  },
  {
    path: 'tracking-otp',
    data: { seoKey: 'trackingOtp', robots: 'noindex, follow' },
    component: TrackingOtpComponent,
  },
];
